import React from "react";
import { useRecoilValue } from "recoil";
import { toggleStore } from "../../../store/switchState";

interface Props {
  children: React.ReactNode;
}

const InputLayout: React.FC<Props> = ({ children }) => {
  const toggle = useRecoilValue(toggleStore);

  return (
    <div
      className={`fixed ${
        toggle ? "w-[calc(100vw-250px)]" : "w-[calc(100vw-35px)]"
      } h-[calc(100vh-190px)] mt-150px mb-60px top-0 overflow-x-scroll m-16px`}
    >
      <div className="flex flex-col">
        <div className="w-full flex-grow">{children}</div>
      </div>
    </div>
  );
};

export default InputLayout;
